var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",style:(_vm.backgroundImage),attrs:{"fluid":"","fill-height":""}},[_c('p-loader'),_vm._v(" "),_c('p-snackbar'),_vm._v(" "),_c('div',{staticClass:"background-mask"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfe9511","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Out.vue
// module id = 1249
// module chunks = 1